import axios from 'axios'
import { getAPIService } from '../../../getServerHost'
import { NewTask } from '../../../types'

export const taskCreate = async (payload: { body: NewTask; type: string }) => {
  const { body, type } = payload
  const response = await axios.post(`${getAPIService}/v2/api/cron-tasks/${type}`, body)
  return response.data
}
